import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "./admin/layout/AdminLayout";
import AdminOverview from "./admin/pages/AdminOverview";
import AdminUsers from "./admin/pages/AdminUsers";
import AdminEvents from "./admin/pages/AdminEvents";
import AdminLogin from "./admin/pages/AdminLogin";
import EnquiriesPage from "./admin/pages/AdminEnquiries";
import AddNewEvent from "./admin/components/events/AddNewEvent";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "./admin/components/ScrollToTop";
import IdleLogout from "./admin/logout/UserLogout";
import ManageTransactions from "./admin/pages/ManageTransaction";
import EditEvent from "./admin/components/events/EditEvent";
export default function App() {
  return (
    <>
    <BrowserRouter>
    <ScrollToTop />
    <IdleLogout minutes={15} />
      <Routes>
        <Route path="/" element={<Navigate to="/admin/login" replace />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="dashboard" element={<AdminOverview />} />
          <Route path="events" element={<AdminEvents />} />
          <Route path="event/add" element={<AddNewEvent />} />
          <Route path="enquiries" element={<EnquiriesPage />} />
          <Route path="transactions" element={<ManageTransactions />} />
          <Route path="event/edit" element={<EditEvent />} />
        </Route>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </BrowserRouter>
    <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      </>
  );
}
